interface ISeeAllData {
  contentId: string;
  contentType: string;
}

export const useSeeAllData = (title: string): ISeeAllData => {
  const contentId = `see-all-${title
    .split(' ')
    .join('-')
    .toLowerCase()}-collections`;
  const contentType = 'See all collections';

  return {
    contentId,
    contentType,
  };
};
